import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLock } from '@fortawesome/pro-regular-svg-icons';
import { fetchTranslation } from '../../../../helpers/i18n';

export default function DocAccessTooLow() {
  return (
    <div className="py-2">
      <h5 className="text-center mb-4">
        <FontAwesomeIcon className="me-2" icon={faFileLock} />
        <strong>{fetchTranslation('broker_action_required')}</strong>
      </h5>
      <p className="text-center m-0">
        {fetchTranslation('broker_action_message')}
      </p>
    </div>
  );
}
